// import React, { useEffect, useState } from 'react';
// import ProductDeyailsCard from '../components/productComponents/productDetailsCard';
// import { apiGET } from '../utilities/apiHelpers';
// import { useParams, Link } from 'react-router-dom';
// import { API_URL } from '../config';
// import { toast } from 'react-toastify';
// import { useSelector } from 'react-redux';
// import scrollToTop from '../utilities/scrollToTop';


// const ProductDeyailsPage = () => {
//     const { id } = useParams();
//     const userId = useSelector((state) => state.user?.userData?.id) || '';
//     const [productInformations, setProductInformations] = useState('');
//     const [productData, setProductData] = useState(null);
//     const [error, setError] = useState(null);
//     const [stepperProgressCartData, setStepperProgressCartData] = useState([]);
//     const [globalConfig, setGlobalConfig] = useState([]);
//     const params = useParams()


//     const getProductInformation = async () => {
//         try {
//             const response = await apiGET(`${API_URL}/v1/product/get-product-details-information-by-product/${id}`);
//             if (response?.data?.status) {
//                 setProductInformations(response?.data?.data);
//                 console.log(productInformations)
//             } else {
//                 console.error("Something went wrong");
//                 setProductInformations(null);
//             }
//         } catch (error) {
//             console.error("Something went wrong", error);
//             setProductData(null);
//         }
//     };


//     const getProductData = async () => {
//         try {
//             const response = await apiGET(`v1/product/get-product/${params.id}`);
//             setProductData(response?.data?.data?.data?.product);
//             console.log(productData)
//             console.log()
//         } catch (error) {
//             setError(error.message || 'Error fetching data');
//         }
//     };

//     const getUserStepperProgress = async () => {
//         try {
//             const stepperResponse = await apiGET(`/v1/stepper-progress/user-stepper-progress/${userId}`)
//             if (stepperResponse?.status) {
//                 setStepperProgressCartData(stepperResponse.data?.data);
//             } else {
//                 toast.error('Error fetching product details');
//             }
//         } catch (error) {
//             toast.error(error)
//         }
//     }

//     const fetchGlobalConfig = async () => {
//         try {
//             const response = await apiGET(`/v1/global-config/get-config`);
//             if (response.status) {
//                 console.log(response?.data?.data?.data[0]);
//                 setGlobalConfig(response?.data?.data?.data[0]);
//             } else {
//                 toast.error('Error fetching global config')
//             }
//         } catch (error) {
//             toast.error('Error', error)
//         }
//     }



//     useEffect(() => {
//         scrollToTop()
//         getProductInformation();
//         getProductData();
//         getUserStepperProgress();
//         fetchGlobalConfig()
//     }, [id]);

//     return (
//         <div className="container mx-auto p-4">
//             <nav class="text-gray-500 mb-4">
//                 <ol class="list-reset flex">
//                     <li><Link to='/' class="text-[#817F7F] hover:underline">Home</Link></li>
//                     <li><span class="mx-2">{">"}</span></li>
//                     <li><Link to='/products' class="text-[#817F7F] hover:underline">All Products</Link></li>
//                     <li><span class="mx-2">{">"}</span></li>
//                     <li class="text-[#101010]">{productData?.name}</li>
//                 </ol>
//             </nav>
//             <ProductDeyailsCard productInformations={productInformations} productData={productData} globalConfig={globalConfig} stepperProgressCartData={stepperProgressCartData} setStepperProgressCartData={setStepperProgressCartData} />
//         </div>

//     );
// };

// export default ProductDeyailsPage;
import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import ProductDeyailsCard from "../components/productComponents/productDetailsCard";
import { apiGET } from "../utilities/apiHelpers";
import { API_URL } from "../config";
import scrollToTop from "../utilities/scrollToTop";

const ProductDeyailsPage = () => {
    const { id } = useParams();
    const userId = useSelector((state) => state.user?.userData?.id) || "";

    const [productInformations, setProductInformations] = useState(null);
    const [productData, setProductData] = useState(null);
    const [stepperProgressCartData, setStepperProgressCartData] = useState({});
    const [globalConfig, setGlobalConfig] = useState({});

    /* ================================
       PRODUCT INFORMATION
    ================================= */
    const getProductInformation = useCallback(async () => {
        try {
            const res = await apiGET(
                `${API_URL}/v1/product/get-product-details-information-by-product/${id}`
            );

            console.log("response++",res);
            

            if (res?.data?.status) {
                setProductInformations(res?.data?.data || null);
            } else {
                setProductInformations(null);
            }
        } catch (error) {
            console.error("Product information error:", error);
            setProductInformations(null);
        }
    }, [id]);

    /* ================================
       PRODUCT DATA
    ================================= */
    const getProductData = useCallback(async () => {
        try {
            const res = await apiGET(
                `${API_URL}/v1/product/get-product/${id}`
            );
            setProductData(res?.data?.data?.data?.product || null);
        } catch (error) {
            console.error("Product data error:", error);
            setProductData(null);
        }
    }, [id]);

    /* ================================
       USER STEPPER / CART
    ================================= */
    const getUserStepperProgress = useCallback(async () => {
        if (!userId) return;

        try {
            const res = await apiGET(
                `/v1/stepper-progress/user-stepper-progress/${userId}`
            );
            if (res?.status) {
                setStepperProgressCartData(res?.data?.data || {});
            } else {
                toast.error("Error fetching cart data");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error fetching cart data");
        }
    }, [userId]);

    /* ================================
       GLOBAL CONFIG
    ================================= */
    const fetchGlobalConfig = useCallback(async () => {
        try {
            const res = await apiGET(`/v1/global-config/get-config`);
            if (res.status) {
                setGlobalConfig(res?.data?.data?.data?.[0] || {});
            } else {
                toast.error("Error fetching global config");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error fetching global config");
        }
    }, []);

    /* ================================
       INITIAL LOAD
    ================================= */
    useEffect(() => {
        scrollToTop();
        getProductInformation();
        getProductData();
        getUserStepperProgress();
        fetchGlobalConfig();
    }, [
        getProductInformation,
        getProductData,
        getUserStepperProgress,
        fetchGlobalConfig,
    ]);

    /* ================================
       UI
    ================================= */
    return (
        <div className="container mx-auto p-4">
            <nav className="text-gray-500 mb-4">
                <ol className="flex">
                    <li>
                        <Link
                            to="/"
                            className="text-[#817F7F] hover:underline"
                        >
                            Home
                        </Link>
                    </li>
                    <li className="mx-2">{">"}</li>
                    <li>
                        <Link
                            to="/products"
                            className="text-[#817F7F] hover:underline"
                        >
                            All Products
                        </Link>
                    </li>
                    <li className="mx-2">{">"}</li>
                    <li className="text-[#101010]">
                        {productData?.name || "Product"}
                    </li>
                </ol>
            </nav>

            <ProductDeyailsCard
                productInformations={productInformations}
                productData={productData}
                globalConfig={globalConfig}
                stepperProgressCartData={stepperProgressCartData}
                setStepperProgressCartData={setStepperProgressCartData}
            />
        </div>
    );
};

export default ProductDeyailsPage;
